import { faInfoCircle, faRemove, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TableRow, TableCell, IconButton, Tooltip, Box, Table, TableBody, TableHead, useMediaQuery, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import { LinearProgressBar } from "src/framework/components/commons/LinearProgressBar";
import theme from "src/theme/light";
import moment from "moment";
import { DropzoneOptions, useDropzone } from "react-dropzone";
import { notifierStore } from "src/framework/store/NotifierStore";
import EllipsisTooltip from "src/framework/components/commons/EllipsisTooltip";

type UploadFileProperties = {
    anexo: AnexoFile,
    index: number;
    disabled?: boolean;
    onRemove: (index: number) => void;
}

type UploadFileDocumentoProperties = {
    title: string;
    keyFile: string;
    toolTipText: string;
    fileType: string;
    disabled?: boolean;
    onSave: (files: AnexoFile[]) => void;
    documents?: any[];
    arquivoAprovado?: boolean
}

export type AnexoFile = {
    index?: number;
    file?: File;
    previewName?: string | null;
    progress?: number;
    fileType?: string;
}

const UploadFile: FC<UploadFileProperties> = ({
    anexo,
    index,
    disabled = false,
    onRemove
}) => {
    const _anexo: AnexoFile = anexo;
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    return <>
        <TableRow>
            <TableCell data-label="Arquivo">
                <Box display={'flex'} alignItems={'center'}>
                    <EllipsisTooltip maxWidth={180} maxCharacters={30}>
                        {String(_anexo.file?.name)}
                    </EllipsisTooltip>
                    <Tooltip title={String(_anexo.previewName)}>
                        <span style={{ cursor: "help", marginLeft: "7px" }}>
                            <FontAwesomeIcon icon={faInfoCircle} color={theme.palette.grey[400]} />
                        </span>
                    </Tooltip>
                </Box>
            </TableCell>
            <TableCell data-label="Tamanho" align="right">{Formater.toString((Number(_anexo?.file?.size || 0) / 1024), TypeRecords.DECIMAL2) + " Kb"}</TableCell>
            <TableCell data-label="Situação" width={120}>
                {_anexo.progress ? _anexo.progress > 99.9 ? "Ok" : <><LinearProgressBar progress={_anexo.progress} /></> : "Pendente"}
            </TableCell>
            <TableCell data-label="Remover" align="right">
                <IconButton size="small" style={{ color: theme.palette.error.main }} onClick={() => onRemove(index)} disabled={disabled}>
                    <FontAwesomeIcon icon={isMobile ? faTrashCan : faRemove} size={isMobile ? "1x" : "sm"} />
                </IconButton>
            </TableCell>
        </TableRow>
    </>
}


const UploadFileDocumentoServico: FC<UploadFileDocumentoProperties> = ({
    title,
    keyFile,
    toolTipText,
    fileType,
    onSave,
    disabled,
    documents,
    arquivoAprovado = false
}) => {
    const [anexoFile, setAnexoFile] = useState<AnexoFile[]>([]);
    const [dropzoneProps, setDropzoneProps] = useState<DropzoneOptions>();
    const { getRootProps, getInputProps } = useDropzone(dropzoneProps);
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(()=>{
        const dropzoneOptions: DropzoneOptions = {
            onDropAccepted: (_files: any) => {
                const now: string = moment().format("YYYYMMDDHHmmss");
                const _anexosSate = [...anexoFile];
                let count = 1;
                for (const file of _files) {
    
                    _anexosSate.push({
                        index: count,
                        file: file,
                        previewName: `${keyFile}`,
                        fileType,
                    });
                    count++;
                }
    
                setAnexoFile(_anexosSate);
                onSave(_anexosSate);
            },
            onDropRejected(fileRejections: any, event: any) {
                const messages = [];
                const errosInformados: string[] = [];
                for (const rejection of fileRejections){
                    const errors = rejection?.errors;
                    for (const error of errors){
                        if (errosInformados.includes(error.code)){
                            continue;
                        }
                        switch(error.code){
                            case "file-invalid-type":
                                errosInformados.push(error.code);
                                messages.push("Formato do arquivo inválido! Necessário anexar um .pdf!")
                                break;
                            case "too-many-files":
                                errosInformados.push(error.code);
                                messages.push("É permitido a inclusão de apenas 1 documento nesse campo.")
                                break;
                        }
                    }
                }
                notifierStore.setNotifier({
                    title: "Aviso!",
                    content: messages,
                    timeOut: 3500,
                    onClose: () => {
                        notifierStore.setOpen(false)
                    }
                })
                notifierStore.setOpen(true);
            },
        }
        if (fileType === "nf_servico_instalacao"){
            dropzoneOptions.accept = ".pdf";
            dropzoneOptions.maxFiles = 1;
        }
        setDropzoneProps(dropzoneOptions);
    },[fileType])

    return <>
        <section className="container" >
           {isMobile ? (
                <div style={{ marginTop: 20, marginBottom: 20 }}>
                    <h4 style={{ display: "inline", margin: 0 }}>
                        {title}
                        <Tooltip title={toolTipText}>
                            <span style={{ cursor: "help", marginLeft: 5, marginBottom: 2, display: "inline-flex", verticalAlign: "middle" }}>
                                <FontAwesomeIcon icon={faInfoCircle} color={theme.palette.grey[400]} />
                            </span>
                        </Tooltip>
                    </h4>
                </div>
            ) : (
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div>
                        <h4>{title}</h4>
                    </div>
                    <div>
                        <Tooltip title={toolTipText}>
                            <span style={{ cursor: "help", marginLeft: "7px" }}>
                                <FontAwesomeIcon icon={faInfoCircle} color={theme.palette.grey[400]} />
                            </span>
                        </Tooltip>
                    </div>
                </div>
            )}
            {!disabled ? 
                (
                   <>
                    { (!anexoFile || !anexoFile?.length) && (
                        <div {...getRootProps({ className: 'dropzone' })} style={{
                            display: "flex",
                            height: isMobile ? "auto" : "80px",
                            color: `${theme.palette.grey[500]}`,
                            border: `dotted 2px ${theme.palette.grey[500]}`,
                            background: `${theme.palette.grey[300]}`,
                            borderRadius: theme.shape.borderRadius,
                            textAlign: "center",
                            alignContent: "center",
                            alignItems: "center",
                            justifyItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}>
                                <input {...getInputProps()} />
                                <Box style={{ padding: "0px 15px" }} display={"flex"} maxWidth={"md"}>
                                    <p style={{ fontSize: "16px", color: "red" }}>*</p>
                                    <p style={{ fontSize: "16px", color: "black" }}>Clique aqui para carregar um ou mais arquivos ou arraste e solte aqui um ou mais arquivo.</p>
                                </Box>
                        </div>
                    )}
                   </>
                ) : (
                    <Tooltip title={arquivoAprovado ? "Arquivo aprovado e não pode ser alterado." : ""}>
                        <div style={{                        
                            minHeight: isMobile ? "auto" : "80px",
                            color: `${theme.palette.grey[500]}`,
                            border: `dotted 2px ${theme.palette.grey[500]}`,
                            background: `${theme.palette.grey[300]}`,
                            borderRadius: theme.shape.borderRadius,
                            textAlign: "left",
                            alignContent: "center",
                            alignItems: "center",
                            justifyItems: "center",
                            justifyContent: "center",
                            cursor: "",
                        }}>
                            <Box style={{ padding: "0px 15px" }}  maxWidth={"md"}>
                                {documents?.map(doc =>{
                                    return(<p style={{ fontSize: "16px", color: "black" }}>{doc}</p>)
                                })}
                            </Box>
                        </div>
                    </Tooltip>
                )
            }
            {
                anexoFile && anexoFile?.length > 0 ? <>
                    <aside>
                        {!isMobile && (<h4>Arquivos</h4>)}
                        <div style={{ display: "flex", flexDirection: "column"}}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Arquivo</TableCell>
                                        <TableCell align="right">Tamanho</TableCell>
                                        <TableCell>Situação</TableCell>
                                        <TableCell align="right"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {anexoFile.map((anexo: AnexoFile, index: number) => {
                                        return <>
                                            <UploadFile
                                                key={`upload-${index}`}
                                                anexo={anexo}
                                                index={index}
                                                onRemove={(index: number) => {
                                                    const _anexosSate = [...anexoFile];
                                                    _anexosSate.splice(index, 1);
                                                    setAnexoFile(_anexosSate);
                                                    onSave(_anexosSate);
                                                }}
                                            />
                                        </>
                                    })}
                                </TableBody>
                            </Table>
                        </div>
                    </aside>
                </> : ""
            }
        </section >
    </>
}

export { UploadFileDocumentoServico }